import { Typography, FormGroup, Grid, Box } from "@mui/material";
import React from "react";
import {
  ICheckboxQuestion,
  IRateAppointment,
} from "../interface/iRateAppointment";
import { RateAppointmentContext } from "../context/rateAppointmentContext";
import CheckBoxQuestion from "./checkBoxQuestion";

const SpeakWithCoachQuestions = (): React.JSX.Element => {
  const {
    rateAppointmentDto,
  }: {
    rateAppointmentDto: IRateAppointment;
  } = React.useContext(RateAppointmentContext);

  return (
    <Box sx={{ pt: 6 }}>
      <Typography
        variant="h6"
        color="initial"
        sx={{
          mb: 1,
          fontWeight: "bold",
          color: (theme) => theme.palette.primary.main,
          textAlign: { xs: "center", sm: "left" },
        }}
      >
        Über folgende Themen konnte ich mit meinem Coach sprechen
      </Typography>
      <FormGroup>
        <Grid container spacing={0} rowSpacing={1}>
          {rateAppointmentDto.speakWithCoachQuestions.map(
            (question: ICheckboxQuestion, index: number) => (
              <Grid item xs={12} md={6} key={index}>
                <CheckBoxQuestion
                  question={question}
                  index={index}
                  identifier={"speakWithCoachQuestions"}
                />
              </Grid>
            )
          )}
        </Grid>
      </FormGroup>
    </Box>
  );
};

export default SpeakWithCoachQuestions;
